// Webpack Imports
import "jquery-inview";
//var Masonry = require( 'masonry-layout' );

(function ($) {
	"use strict";

	$(function () {
		var $postgrid = $("#product-grid"),
			$posttemplate = $("#tmpl-list-item").html(),
			$productcategories = $("#product-categories"),
			$productcollections = $("#product-collections"),
			//$orderby = $( '#orderby' ),
			$loadmore = $(".load-more");

		// Posts: AJAX-Load (more) items
		if ($postgrid.length) {
			function loadGridItems() {
				var $page = parseInt($loadmore.attr("data-page")),
					$per_page = 12;

				$page++;

				$loadmore.attr("data-page", $page);

				$postgrid.attr("aria-busy", "true");

				$.ajax({
					url: wpApiMonir.url + "grid", // see functions.php
					data: {
						category: $productcategories.val(),
						collection: $productcollections.val(),
						//'orderby': $orderby.val(),
						page: $page, // Get current page-#
						per_page: $per_page,
					},
					type: "GET",
					dataType: "json",
				})
					.done(function (data, textStatus, request) {
						//console.log( data );

						var count_total_results = parseInt(data.total),
							count_total_pages = parseInt(data.totalpages),
							elements = JSON.parse(data.elements);

						//console.log( '[' + new Date().toLocaleString() + '] Current Page: ' + $loadmore.attr( 'data-page' ) + '/' + $loadmore.attr( 'data-pagetotal' ) );

						$("#count").html(data.count);

						if (count_total_pages <= $page) {
							$loadmore.addClass("d-none");
						}

						if (count_total_results > 0) {
							if (1 === $page) {
								$loadmore.attr("data-pagetotal", count_total_pages);

								//$postgrid.append( '<li class="grid-sizer col-md-3"></li><!-- https://masonry.desandro.com/layout.html#responsive-layouts -->' );
							}

							for (var i = 0; i < elements.length; i++) {
								var element = elements[i];
								//console.log( element );

								// Append HTML content
								if (
									element.class &&
									element.link &&
									element.title &&
									element.image
								) {
									$postgrid.append(
										$posttemplate
											.replace(/{{position}}/g, ++$postgrid.children().length) // https://www.w3.org/TR/wai-aria-practices-1.1/examples/feed/feed.html
											.replace(/{{class}}/g, element.class)
											.replace(/{{link}}/g, element.link)
											.replace(/{{title}}/g, element.title)
											.replace(/{{image}}/g, element.image)
									);
								}
							}

							// Initialize "Products" Masonry Grid
							/*new Masonry( '#product-grid', {
								itemSelector: '.grid-item',
								columnWidth: '.grid-sizer',
								percentPosition: true,
							} );*/

							// https://www.w3.org/TR/wai-aria-practices-1.1/examples/feed/feed.html
							$postgrid
								.attr("aria-busy", "")
								.children()
								.attr("aria-setsize", $postgrid.children().length);

							// Focus first new item
							if (1 !== $page) {
								$postgrid
									.find("li")
									.eq(--$page * $per_page)
									.trigger("focus");
							}
						}
					})
					.fail(function () {
						$loadmore.css({ display: "none" });
					});
			}

			// "On button click"
			/*$loadmore.on( 'click', function ( e ) {
				e.preventDefault();

				if ( parseInt($loadmore.attr( 'data-page' )) < parseInt($loadmore.attr( 'data-pagetotal' )) ) {
					loadGridItems();
				}
			} );*/

			// "On scroll"
			$loadmore.on("inview", function (event, isInView) {
				if (
					isInView &&
					parseInt($loadmore.attr("data-page")) <
						parseInt($loadmore.attr("data-pagetotal"))
				) {
					//console.log( '[Load on scroll] Current Page: ' + $loadmore.attr( 'data-page' ) + '/' + $loadmore.attr( 'data-pagetotal' ) );
					loadGridItems();
				}
			});

			// "On select"
			$("#product-categories, #product-collections, #orderby").on(
				"change",
				function () {
					// Update Browser URL
					if (typeof history.pushState !== undefined) {
						var permalink =
							$productcategories.data("permalink") +
							($productcategories.val() != ""
								? "category/" + $productcategories.val() + "/"
								: "") +
							($productcollections.val() != ""
								? "collection/" + $productcollections.val() + "/"
								: "");
						history.pushState(null, null, permalink);
					}

					$postgrid.css("height", "auto").html("");
					$loadmore.removeClass("d-none").attr("data-page", 0); // Reset
					loadGridItems();
				}
			);

			// Preselected options onload?
			if ($productcategories.data("value")) {
				$productcategories
					.val($productcategories.data("value"))
					.trigger("change");
			}
			if ($productcollections.data("value")) {
				$productcollections
					.val($productcollections.data("value"))
					.trigger("change");
			}
			/*if ( $orderby.data( 'value' ) ) {
				$orderby.val( $orderby.data( 'value' ) ).trigger( 'change' );
			}*/

			// "On load" (not needed if options are preselected/triggered onload - see above)
			if (
				!$productcategories.data("value") &&
				!$productcollections.data("value") /*&& ! $orderby.data( 'value' ) */
			) {
				loadGridItems();
			}
		}

		// Initialize "Related" Masonry Grid
		/*if ( $( '#related-grid' ).length ) {
			new Masonry( '#related-grid', {
				itemSelector: '.grid-item',
				columnWidth: '.grid-sizer',
				percentPosition: true,
			} );
		}*/
	});
})(jQuery);
